"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M13.736 15.74a8 8 0 0 0 2.475-1.024 1.25 1.25 0 0 0-1.33-2.112 5.41 5.41 0 0 1-5.734 0 1.247 1.247 0 0 0-1.718.388q0 .003-.002.004a1.246 1.246 0 0 0 .39 1.718l.002.002a7.9 7.9 0 0 0 2.472 1.023l-2.382 2.382a1.234 1.234 0 0 0-.019 1.744l.021.021c.237.243.557.365.876.365s.639-.121.877-.365l2.352-2.34 2.34 2.341a1.248 1.248 0 0 0 1.764-1.763zm-1.723-3.473a4.264 4.264 0 0 0 4.259-4.257c0-2.347-1.911-4.259-4.259-4.259s-4.259 1.911-4.259 4.26a4.26 4.26 0 0 0 4.259 4.256m0-6.02a1.763 1.763 0 1 1 0 3.528 1.763 1.763 0 0 1 0-3.529z"
}), 'Odnoklassniki');
//# sourceMappingURL=index.js.map